import { type ReactNode, useEffect, useRef } from "react";

interface Props {
  align: "start" | "center";
  children: ReactNode;
}

/* An "announcing" header that focuses itself on initial load. Which sets
 * the focus at the top and announces the header for screen readers. Which
 * aleviates the lack of context when screens change.
 *
 * It's a bit of a hack, but is less invasive than creating and managing a
 * status element that sticks around across different screens.
 *
 * Note: There's a `:focus-visible` part in the CSS that goes along with this.
 */
export const AnnouncingHeader = ({ children, align }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref.current]);

  return (
    <div
      className={`sid-header__title ${
        align === "center" ? "sid-l-horz-center" : ""
      } sid-l-space-top-md`}
      tabIndex={-1}
      ref={ref}
    >
      {children}
    </div>
  );
};
